import React from 'react'

const AssessmentAreaTreated = (props) => {
    let { assessmentData, setAssessmentData, setSaveAssessmentAreaTreatedData } = { ...props };
    let assessmentAreaTreated = assessmentData?.AssessmentAreaTreated;

    const handleAssessmentAreaTreated  = (e) => {
        let { name } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setAssessmentData(prev => {
        console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'AssessmentAreaTreated': {
                    ...prev?.AssessmentAreaTreated,
                    [name]: prev?.AssessmentAreaTreated?.[name] === "true" ? "false" : "true",
                },
            })
            return ({
                ...prev,
                'AssessmentAreaTreated': {
                    ...prev?.AssessmentAreaTreated,
                    [name]: prev?.AssessmentAreaTreated?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveAssessmentAreaTreatedData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }
  return (
        <div className="d-flex align-items-center gap-18 flex-wrap row-gap-10">
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_FullBody"
                    id="AAT_FullBody"
                    checked={assessmentAreaTreated?.AAT_FullBody === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Full Body</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_LowerBody"
                    id="AAT_LowerBody"
                    checked={assessmentAreaTreated?.AAT_LowerBody === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Lower Body</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Neck"
                    id="AAT_Neck"
                    checked={assessmentAreaTreated?.AAT_Neck === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Neck</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Abdoment"
                    id="AAT_Abdoment"
                    checked={assessmentAreaTreated?.AAT_Abdoment === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Abdomen</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_BackMid"
                    id="AAT_BackMid"
                    checked={assessmentAreaTreated?.AAT_BackMid === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Back(mid)</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Shoulder"
                    id="AAT_Shoulder"
                    checked={assessmentAreaTreated?.AAT_Shoulder === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Shoulder</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Hand"
                    id="AAT_Hand"
                    checked={assessmentAreaTreated?.AAT_Hand === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Hand</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_LegUpper"
                    id="AAT_LegUpper"
                    checked={assessmentAreaTreated?.AAT_LegUpper === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Leg(upper)</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Foot"
                    id="AAT_Foot"
                    checked={assessmentAreaTreated?.AAT_Foot === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Foot</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_UpperBody"
                    id="AAT_UpperBody"
                    checked={assessmentAreaTreated?.AAT_UpperBody === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Upper Body</p>
            </label>

            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Jaw"
                    id="AAT_Jaw"
                    checked={assessmentAreaTreated?.AAT_Jaw === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Jaw</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Chest"
                    id="AAT_Chest"
                    checked={assessmentAreaTreated?.AAT_Chest === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Chest(Pectoral Region)</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_BackUpper"
                    id="AAT_BackUpper"
                    checked={assessmentAreaTreated?.AAT_BackUpper === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Back(upper)</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_BackLower"
                    id="AAT_BackLower"
                    checked={assessmentAreaTreated?.AAT_BackLower === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Back(lower)</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Arm"
                    id="AAT_Arm"
                    checked={assessmentAreaTreated?.AAT_Arm === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Arm</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Hip"
                    id="AAT_Hip"
                    checked={assessmentAreaTreated?.AAT_Hip === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Hip</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_LegLower"
                    id="AAT_LegLower"
                    checked={assessmentAreaTreated?.AAT_LegLower === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Leg(lower)</p>
            </label>
            
            <label className="d-flex align-items-center gap-6 user-select-none">
                <div className="custom_check_box d-flex">
                <input
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="AAT_Other"
                    id="AAT_Other"
                    checked={assessmentAreaTreated?.AAT_Other === "true"}
                    onChange={handleAssessmentAreaTreated}
                />
                </div>
                <p className="text lh-12">Other</p>
            </label>

        </div>
  )
}

export default AssessmentAreaTreated